import { FC } from 'react';
import { Typography } from '@mui/material';

import { RouterLink } from '@components/base';
import { DocumentTitleSegment as TitleSegment } from '@hooks/useDocumentContext';

type PageTitleSegmentProps = {
  segment: TitleSegment;
};

const Breadcrumb: FC<PageTitleSegmentProps> = ({ segment }) =>
  segment.route ? (
    <RouterLink color='inherit' to={segment.route} variant='body2'>
      {segment.title}
    </RouterLink>
  ) : (
    <Typography color='inherit' minWidth={0} noWrap variant='body2'>
      {segment.title}
    </Typography>
  );

export default Breadcrumb;
